import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["errorMessage"]; // Declare error message target

  connect() {
    console.log("TrixController connected");
    console.log("Error message target:", this.errorMessageTarget);
  }

  initialize() {
    console.log("TrixController initialized");
    this.element.addEventListener("trix-file-accept", this.validateFileSize.bind(this));
  }

  // File size validation logic
  validateFileSize(event) {
    const maxFileSize = 1024 * 1024 * 5; // 5MB
    const file = event.file;

    if (file.size > maxFileSize) {
      console.log("TrixController max file size exceeded");
      event.preventDefault(); // Prevent the file from being added
      this.showErrorMessage("File size must not exceed 5MB.");
      // this.showAlert("File size must not exceed 5MB."); // Show alert
    } else {
      console.log("TrixController file size is valid");
      this.hideErrorMessage();
    }
  }

  // Display error message dynamically
  showErrorMessage(message) {
    if (this.hasErrorMessageTarget) {
      console.log("TrixController show error message");
      // this.errorMessageTarget.textContent = message;
      this.errorMessageTarget.classList.remove("d-none");
    }
  }

  // Hide error message dynamically
  hideErrorMessage() {
    if (this.hasErrorMessageTarget) {
      console.log("TrixController hide error message");
      // this.errorMessageTarget.textContent = "";
      this.errorMessageTarget.classList.add("d-none");
    }
  }

  // Show a popup alert
  showAlert(message) {
    alert(message); // Display a browser alert
  }
}